import ManageSurveyPage from "components/Survey/Manage/ManageSurveyPage";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTeamContext } from "store/contexts/teamContext";

export default () => {
  const { team } = useTeamContext();
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    const allowedRoles = [2, 3];
    if (!allowedRoles.includes(team?.role_id)) {
      history.replace(`/teams/${params.teamId}/wellness/survey`);
    }
  }, [team?.role_id, history, params]);

  return <ManageSurveyPage />;
};
